import formName from 'constants/formName'
import { actions } from 'data'
import { TierTwoStepType } from 'data/types'
import { put } from 'redux-saga/effects'

export const goToStep = function* (step: TierTwoStepType) {
  yield put(actions.form.change(formName.TIER_TWO, 'step', step))
}
